import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const PlantPerformanceIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Plant Performance</title>
    <path d="M41 16v6h-2v-8h-8v-2h6V8H21v4h6v2h-6l-3 6H9v4H7v-4H3v12h4v-4h2v4h3l3 8h24V26h2v6h4V16zM25.5 37l1-9h-5l9-12-1 10h5z" />
  </IconBase>
);
